import React, { ChangeEvent } from "react";
import styled from "styled-components";

type TextAreaFieldComponentProps = {
  id?: string;
  className?: string;
  name?: string;
  placeholder?: string;
  mb?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string | number;
  required?: boolean;
  autoFocus?: boolean;
};

const TextAreaFieldStyle = styled.div<{ $mb?: string }>`
  margin-bottom: ${(props) => props.$mb || "0"};
  width: 100%;

  textarea {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 25px;
    box-sizing: border-box;
    color: #222;
    font-size: 16px;
    outline: none;
    resize: vertical;
    padding: 10px 20px;
    width: 100%;
    min-height: 50px;
    height: 200px;
  }
`;

const TextAreaField: React.FC<TextAreaFieldComponentProps> = ({
  id,
  className,
  name,
  placeholder,
  mb,
  onChange,
  value,
  required,
  autoFocus,
}) => {
  return (
    <TextAreaFieldStyle className={className} $mb={mb}>
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        required={required}
        autoFocus={autoFocus}
      />
    </TextAreaFieldStyle>
  );
};

export default TextAreaField;
